import React from "react";
import {
  WebsiteSchema,
  SiteNavigationElementSchema,
  FoodEstablishmentSchema,
  Navigation,
  RecaptchaProvider,
  Footer,
  SocialMedia,
  SiteMap,
  CopyrightLabel,
  OutboundLink,
  FishermanBanner,
} from "@bluefin/components";
import { Image, Grid, h3 } from "semantic-ui-react";
import { graphql, StaticQuery } from "gatsby";

import { getPageHeroImage } from "../utils/utils";
import "../semantic/semantic.less";
import "../style/WebsiteLayout.css";

export default ({ children }) => (
  <StaticQuery
    query={graphql`
      query {
        fishermanBusiness {
          name
          type
          logo
          menu {
            schedules {
              availableDays
              categories
              _id
              name
            }
            categories {
              items
              name
              _id
            }
            items {
              modifierSets
              description
              _id
              name
              variations {
                _id
                menuItem
                name
                order
                price
              }
            }
            modifierSets {
              _id
              minAllowed
              modifiers
              name
            }
            modifiers {
              _id
              name
              price
            }
          }
          gatsbyLogo {
            childImageSharp {
              gatsbyImageData(layout: FIXED, height: 60)
            }
          }
          socialMedia {
            link
            type
          }
        }
        allFishermanBusinessWebsitePage(
          sort: { order: ASC, fields: navigationPriority }
        ) {
          nodes {
            slug
            description
            title
            pageType
            url
            navigationPriority
            groupName
            props
          }
        }
        allFishermanBusinessLocation {
          nodes {
            street
            city
            state
            zipCode
            country
            email
            phoneNumber
            name
            hours {
              open
              close
              day
            }
          }
        }
        fishermanBusinessWebsitePage(title: { eq: "Home" }) {
          components {
            fastId
            order
            files {
              file
              gatsbyFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const {
        fishermanBusiness,
        allFishermanBusinessWebsitePage,
        allFishermanBusinessLocation,
        fishermanBusinessWebsitePage,
      } = data;

      return (
        <React.Fragment>
          <WebsiteSchema
            name={fishermanBusiness.name}
            url={"https://bunmeup.com"}
          />
          <SiteNavigationElementSchema
            pages={allFishermanBusinessWebsitePage.nodes}
            siteUrl={"https://bunmeup.com"}
          />
          <FoodEstablishmentSchema
            name={fishermanBusiness.name}
            siteUrl={"https://bunmeup.com"}
            businessType={fishermanBusiness.type}
            logo={fishermanBusiness.logo}
            address={allFishermanBusinessLocation.nodes}
            menu={fishermanBusiness.menu}
            images={getPageHeroImage({
              options: fishermanBusinessWebsitePage.components,
            })}
          />
          <div className={"site-container"}>
            <div>
              <div className={"top-navigation-container"}>
                <Navigation
                  links={[...allFishermanBusinessWebsitePage.nodes]}
                  bordered={false}
                  centerMobileNavItems={true}
                  fixed={false}
                  header={fishermanBusiness.name}
                  logo={fishermanBusiness.gatsbyLogo.childImageSharp}
                  linksAs={"text"}
                  primaryContentCentered={false}
                />
                <a
                  href={
                    "https://www.catercow.com/catering/8335-bun-me-up/referral "
                  }
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  className={"order-online-image-link"}
                >
                  <Image
                    size={"medium"}
                    centered={true}
                    src={
                      "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/cc-btn-blue_1.png"
                    }
                  />
                </a>
              </div>
            </div>
            <RecaptchaProvider>
              <div className={"page-container"}>{children}</div>
              <Grid
                stackable={true}
                className={"partners-logo"}
                verticalAlign={"middle"}
                textAlign={"center"}
              >
                <Grid.Column width={16} textAlign={"center"}>
                  <h3>Companies We Cater For</h3>
                  <Grid textAlign={"center"} verticalAlign={"middle"}>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/J.P.-Morgan-Chase-Logo-2000-removebg-preview.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/Lunar_Energy_3Hw3n44.jpg"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/ebay-removebg-preview.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/Genentech_Logo.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/nvidia-logo-vert.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/synopsys-removebg-preview.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/intuit-removebg-preview.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/freshworks-removebg-preview.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"8"} tablet={"6"} computer={"3"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/Untitled_design-removebg-preview.png"
                        }
                      />
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                <Grid.Column width={16} textAlign={"center"}>
                  <h3>Our Approved/Preferred Catering Partnerships</h3>
                  <Grid
                    textAlign={"center"}
                    verticalAlign={"middle"}
                    columns={"3"}
                  >
                    <Grid.Column mobile={"5"} tablet={"3"} computer={"2"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/043014_Primary_Mark_WEB_01-removebg-preview.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"5"} tablet={"3"} computer={"2"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/f_m7av3zx01.png"
                        }
                      />
                    </Grid.Column>
                    <Grid.Column mobile={"5"} tablet={"3"} computer={"2"}>
                      <Image
                        size={"medium"}
                        centered={true}
                        src={
                          "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/EA9409F1-922C-49C8-B320-5848B4AB4471.jpeg"
                        }
                      />
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              </Grid>
              <Footer
                backgroundColor={"primary"}
                horizontalAlign={"center"}
                verticalAlign={"middle"}
                columns={[
                  <div>
                    <SocialMedia
                      socialMediaValues={fishermanBusiness.socialMedia}
                      buttonType={"circle"}
                      centerHeader={false}
                      colors={"secondary"}
                      groupButtons={false}
                      groupVertically={false}
                      header={""}
                      inverted={false}
                      labelPosition={"free"}
                      showLabels={false}
                    />
                    <SiteMap
                      links={allFishermanBusinessWebsitePage.nodes}
                      horizontal={true}
                      bulleted={false}
                    />
                    <CopyrightLabel
                      company={fishermanBusiness.name}
                      phrase={"All Rights Reserved"}
                      privacyPolicyLink={
                        <OutboundLink
                          to={
                            "https://fisherman-static.s3.amazonaws.com/public/__fisherman/Client+Website+Privacy+Policy.pdf"
                          }
                          label={"Privacy Policy"}
                          eventLabel={"copyright-privacy-policy"}
                        />
                      }
                    />
                  </div>,
                ]}
              />
            </RecaptchaProvider>
          </div>
          <FishermanBanner />
        </React.Fragment>
      );
    }}
  />
);
